import {
  GET_USER_INFO,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO_FAILED,
  GET_SELECTED_CODE,
  GET_GUID,
} from "./actionsTypes";

const initialState = {
  users: {},
  loadingSettings: false,
  error: {
    message: "",
  },
  selectedCode: "",
  guid: "",
};

const UsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_INFO:
      state = { ...state, loadingSettings: true };
      break;
    case GET_USER_INFO_SUCCESS:
      state = { ...state, users: action.payload, loadingSettings: false };
      break;
    case GET_USER_INFO_FAILED:
      state = {
        ...state,
        error: {
          message: "Error",
        },
        loadingSettings: false,
      };
      break;
    case GET_SELECTED_CODE:
      state = {
        ...state,
        selectedCode: action.payload,
        loadingSettings: false,
      };
      break;
    case GET_GUID:
      state = {
        ...state,
        guid: action.payload,
        loadingSettings: false,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UsersReducer;
